module.exports = __webpack_public_path__ + "img/parent1.f547b189.png";